export default __webpack_public_path__ + "static/media/Cliente.91fd83a6.svg";